// extracted by mini-css-extract-plugin
export default {"btnSubmit":"BtnSubmit_btnSubmit__zqzUx"};